import React, { useMemo } from 'react';
import Modal from '../../../components/common/modal/Modal';
import ButtonComponent from '../../../components/common/button/Button';
import DataTable from '../../../components/common/datatable/DataTable';
import { Loader } from '../../../components/common/Loader';

const HistoryLog = ({ open, onClose, rows = [], loading = false }) => {
  const historyLogColumns = useMemo(
    () => [
      { field: 'quotaNumber', headerName: 'Quota Number', resizable: false },
      { field: 'changedOn', headerName: 'Changed On', resizable: false },
      { field: 'changedBy', headerName: 'Changed By', resizable: false },
      { field: 'field', headerName: 'Field', resizable: false },
      { field: 'oldValue', headerName: 'Old Value',  resizable: false },
      { field: 'newValue', headerName: 'New Value',  resizable: false },
      { field: 'status', headerName: 'Status',  resizable: false },
    ],
    []
  );

  const historyLogRows = useMemo(
    () =>
      (rows || []).map((item, index) => ({
        ...item,
        id: `history-${item?.changedOn || 'ts'}-${index}`,
       
      })),
    [rows]
  );

  return (
    <Modal
      open={open}
      handleClose={onClose}
      title="Quota Maintenance - History Log"
      maxWidth="lg"
      fullWidth={true}
      
      content={
        loading ? (
          <Loader />
        ) : (
          <DataTable
            height={400}
            rows={historyLogRows}
            columns={historyLogColumns}
            defaultColDef={{ sortable: true, filter: true, resizable: true }}
            paginationProp={true}
            paginationPageSize={50}
            paginationPageSizeSelector={[50, 100, 500, 1000]}
            getRowId={(params) => params.data.id}
          />
        )
      }
      action={
        <ButtonComponent
          label="Close"
          bgColor="#111827"
          color="#fff"
          onClick={onClose}
        />
      }
    />
  );
};

export default HistoryLog;